import {
  DEALER_CREATE,
  DEALER_UPDATE,
  DEALER_DELETE,
  DEALER_FETCH,
  DEALER_FETCH_SUCCESS,
  DEALER_FETCH_RESET,
  DEALERS_FETCH,
  DEALERS_FETCH_SUCCESS,
  DEALERS_FETCH_RESET,
  DEALERS_EXPORT_EXCEL,
} from './types';

export const dealerFetch = id => {
  return {
    type: DEALER_FETCH,
    payload: id,
  };
};

export const dealerFetchSuccess = payload => {
  return {
    type: DEALER_FETCH_SUCCESS,
    payload: payload,
  };
};

export const dealerFetchReset = () => {
  return {
    type: DEALER_FETCH_RESET,
  };
};

export const dealersFetch = payload => {
  return {
    type: DEALERS_FETCH,
    payload: payload,
  };
};

export const dealersFetchSuccess = payload => {
  return {
    type: DEALERS_FETCH_SUCCESS,
    payload: payload,
  };
};

export const dealersFetchReset = () => {
  return {
    type: DEALERS_FETCH_RESET,
  };
};

export const dealersExportExcel = payload => {
  return {
    type: DEALERS_EXPORT_EXCEL,
    payload: payload,
  };
};

export const dealerCreate = values => {
  return {
    type: DEALER_CREATE,
    payload: values,
  };
};

export const dealerUpdate = values => {
  return {
    type: DEALER_UPDATE,
    payload: values,
  };
};

export const dealerDelete = id => {
  return {
    type: DEALER_DELETE,
    payload: id,
  };
};
